import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './AuthForms.css';
import ErrorMessage from './ErrorMessage';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const response = await axios.post('/api/auth/login', formData, {
        withCredentials: true
      });
      
      if (response.data.success) {
        // Store the token
        localStorage.setItem('token', response.data.token);
        // Navigate to trends page
        navigate('/api/trends', { replace: true });
      } else {
        setError({ message: 'Login failed' });
      }
    } catch (err) {
      console.error('Login error:', err.response?.data || 'Login failed');
      setError(err.response?.data || { message: 'Login failed' });
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Login</h2>
        <ErrorMessage error={error} />
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="auth-button">Login</button>
        </form>
        <p className="auth-link">
          Don't have an account? <Link to="/api/auth/signup">Sign Up</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
